import { styled } from '@sds-system/system';
import { borderRadius } from '@sds-system/theme';
import { getAllStyledProps } from '@sds-system/utils';
import type {
  StyledIndicatorCircleOptions,
  StyledIndicatorDotProps,
  StyledIndicatorNumberProps,
  StyledIndicatorRootProps,
} from './Indicator.types';

export const StyledIndicatorWrapper = styled('div')<StyledIndicatorRootProps>(() => {
  return {};
}, getAllStyledProps);

export const StyledDot = styled('div')<StyledIndicatorDotProps>(
  () => {
    return {
      borderRadius: borderRadius[999],
      cursor: 'pointer',
    };
  },
  () => ({
    variants: [
      {
        props: { size: 'S' },
        style: {
          width: 4,
          height: 4,
        },
      },
      {
        props: { size: 'M' },
        style: {
          width: 6,
          height: 6,
        },
      },
      {
        props: { size: 'L' },
        style: {
          width: 8,
          height: 8,
        },
      },
    ],
  }),
  getAllStyledProps,
);

export const StyledNumber = styled('div')<StyledIndicatorNumberProps>(
  () => {
    return {
      gap: 8,
    };
  },
  ({ theme }) => ({
    variants: [
      {
        props: { variant: 'number.solid' },
        style: {
          backgroundColor: theme.palette.bg.dimmer[80],
          color: theme.palette.text.interactive.inverse,
        },
      },
      {
        props: { variant: 'number.line' },
        style: {
          border: `1px solid ${theme.palette.border.interactive.secondary}`,
          borderRadius: borderRadius[24],
        },
      },
      {
        props: { size: 'S' },
        style: {
          gap: 4,
          padding: '4px 12px',
        },
      },
      {
        props: { size: 'M' },
        style: {
          padding: '8px 16px',
        },
      },
      {
        props: { size: 'L' },
        style: {
          padding: '10px 20px',
        },
      },
    ],
  }),
  getAllStyledProps,
);
export const StyledIndicatorCircle = styled('div')<StyledIndicatorCircleOptions>(({ theme }) => {
  return {
    width: 4,
    height: 4,
    borderRadius: borderRadius[999],
    backgroundColor: theme.palette.icon.tertiary,
    opacity: 0.5,
  };
});
